<template>
  <spinner v-if="loading" position="center"></spinner>
  <div v-else>DZIĘKI</div>
</template>

<script>
import api from "@/services/api";
import spinner from "@/components/partials/misc/spinner";
import $ from "jquery";

export default {
  data() {
    return {
      loading: false,
    };
  },
  components: {
    spinner,
  },
  name: "mailingThanks",
  mounted() {
    let self = this;
    api.post(
      "/campaign/" + this.$route.params.slug,
      {},
      function () {
        self.loading = false;
      },
      function (data) {
        self.error = data.message;
        self.loading = false;
        $("html,body").animate({ scrollTop: $(document).height() }, "slow");
      },
      function () {
        self.error = null;
        self.loading = true;
      }
    );
  },
};
</script>
